import { render, staticRenderFns } from "./recheckStudent.vue?vue&type=template&id=7916a454&scoped=true"
import script from "./recheckStudent.vue?vue&type=script&lang=js"
export * from "./recheckStudent.vue?vue&type=script&lang=js"
import style0 from "./recheckStudent.vue?vue&type=style&index=0&id=7916a454&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7916a454",
  null
  
)

export default component.exports